module.exports = __webpack_public_path__ + "media/assets/images/login-bg-9a82705c8fe0a2f9f5434cd9aec67148.jpg";